import { render, staticRenderFns } from "./DockActionsDialog.vue?vue&type=template&id=5c3f7960&"
import script from "./DockActionsDialog.vue?vue&type=script&lang=js&"
export * from "./DockActionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports